export const RedCheckbox =
  'peer h-4 w-4 rounded-sm border-gray-300 focus-visible:outline-none focus-visible:!ring-1 focus-visible:!ring-red-500 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#EE3E5C] data-[state=checked]:border-[#EE3E5C] data-[state=checked]:text-white';
